import axios from '../helpers/axios'

/**
 * Раздел «Деньги»: приход, долги по заказам, деление заработка и выплаты.
 * Сервер: controller/adminMoney.js. Все суммы — в рублях.
 */
export const getMoneyErrorMessage = (error, fallback = 'Не удалось загрузить данные') => (
  error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback
)

const periodParams = (period = {}) => ({
  from: period.from || undefined,
  to: period.to || undefined,
})

export const fetchMoneyOverview = async (period) => {
  const res = await axios.get('/admin-money/overview', { params: periodParams(period) })
  return res.data
}

/** Лента операций. before — nextBefore из прошлого ответа, чтобы листать вглубь. */
export const fetchMoneyLedger = async (period, before = '') => {
  const res = await axios.get('/admin-money/ledger', {
    params: { ...periodParams(period), limit: 100, before: before || undefined },
  })
  return {
    items: res.data?.items || [],
    hasMore: !!res.data?.hasMore,
    nextBefore: res.data?.nextBefore || '',
  }
}

/** Заказы постранично, страницы с 1. */
export const fetchMoneyOrders = async (period, page = 1) => {
  const res = await axios.get('/admin-money/orders', { params: { ...periodParams(period), limit: 100, page } })
  return { orders: res.data?.orders || [], hasMore: !!res.data?.hasMore, page }
}

/** Пересчитать заказ по сегодняшним процентам и режиму «пополам». */
export const recalcMoneyOrder = async (orderId) => {
  await axios.post(`/admin-money/orders/${orderId}/recalc`)
}

/** Остатки за всё время: начислено, выплачено, осталось — по каждому получателю. */
export const fetchMoneyBalances = async () => {
  const res = await axios.get('/admin-money/balances')
  return { recipients: res.data?.recipients || [], limited: !!res.data?.limited }
}

export const fetchMoneyPayouts = async () => {
  const res = await axios.get('/admin-money/payouts', { params: { limit: 300 } })
  return res.data?.payouts || []
}

export const createMoneyPayout = async (payload) => {
  const res = await axios.post('/admin-money/payouts', payload)
  return res.data?.payout
}

export const deleteMoneyPayout = async (id) => {
  await axios.delete(`/admin-money/payouts/${id}`)
}

/** Фактические затраты по заказу. costs = null — вернуть расчётные. */
export const saveMoneyOrderCost = async (orderId, costs, comment = '') => {
  const res = await axios.put(`/admin-money/orders/${orderId}/cost`, { costs, comment })
  return res.data
}

export const fetchMoneySettings = async () => {
  const res = await axios.get('/admin-money/settings')
  return res.data
}

export const saveMoneySettings = async (payload) => {
  const res = await axios.put('/admin-money/settings', payload)
  return res.data
}

export const createMoneyTestOrder = async (payload) => {
  const res = await axios.post('/admin-money/test-order', payload)
  return res.data?.order
}

export const deleteMoneyTestOrders = async () => {
  const res = await axios.delete('/admin-money/test-orders')
  return Number(res.data?.deleted || 0)
}
